var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "textSection"
  }, [_vm.tableData && _vm.tableData.labelHtml ? _c('div', [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.tableData.labelHtml
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "tableContainer"
  }, [_vm.image && _vm.image.src ? _c('div', {
    staticClass: "imageSection"
  }, [_c('img', {
    staticClass: "tableImage",
    attrs: {
      "src": _vm.image && _vm.image.src
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "tableSection"
  }, [_vm.tableData ? _c('activity-table', [_c('thead', [_c('tr', _vm._l(_vm.tableData.headers, function (header) {
    return _c('th', {
      key: header.label
    }, [_vm._v(_vm._s(header.label))]);
  }), 0)]), _c('tbody', _vm._l(_vm.tableData.rows, function (row, idx) {
    return _c('tr', {
      key: idx,
      class: _vm.getRowClass(row.values.some(function (val) {
        return val.correct;
      }))
    }, _vm._l(row.values, function (value, vIdx) {
      return _c('td', {
        key: value.value
      }, [_vm.tableData.headers[vIdx] && _vm.tableData.headers[vIdx].columnType === _vm.KeyboardingTableColumnType.TALLY_MARK ? _c('tally-marks', {
        attrs: {
          "value": value.value
        }
      }) : _c('div', [_vm._v(_vm._s(value.value))])], 1);
    }), 0);
  }), 0)]) : _vm._e()], 1)]), _c('div', {
    staticClass: "text bottomText"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.textHtml
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }